// Product page — option selection → variant, gallery thumbs, qty
(function(){
  var form=document.getElementById('product-form'); if(!form) return;
  var select=document.getElementById('variant-id');
  var priceEl=document.getElementById('price');
  var chosen={};
  form.querySelectorAll('[data-opt]').forEach(function(b){
    chosen[b.dataset.opt]=form.querySelector('[data-opt="'+b.dataset.opt+'"].on')?form.querySelector('[data-opt="'+b.dataset.opt+'"].on').dataset.val:b.dataset.val;
  });
  function sync(){
    // build title from chosen options in order
    var opts=[]; Object.keys(chosen).sort().forEach(function(k){opts.push(chosen[k]);});
    var want=opts.join(' / ');
    for(var i=0;i<select.options.length;i++){
      if(select.options[i].textContent===want){select.selectedIndex=i;var pr=select.options[i].dataset.price;if(pr&&priceEl)priceEl.textContent=pr;break;}
    }
  }
  form.querySelectorAll('[data-opt]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var grp=form.querySelectorAll('[data-opt="'+btn.dataset.opt+'"]');
      grp.forEach(function(x){x.classList.remove('on');});
      btn.classList.add('on');
      chosen[btn.dataset.opt]=btn.dataset.val;
      var lbl=btn.closest('div').previousElementSibling;
      sync();
    });
  });
  window.ecQty=function(d){var s=document.getElementById('q');var v=Math.max(1,parseInt(s.textContent)+d);s.textContent=v;document.getElementById('qty-input').value=v;};
  // gallery — thumbnail click swaps the single main image
  document.querySelectorAll('#thumbs img').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('#thumbs img').forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      var main=document.getElementById('gmain-img');
      if(main && t.dataset.full){main.src=t.dataset.full;main.alt=t.alt;}
    });
  });
})();

// Custom measurements modal — required on every product, no standard sizing
(function(){
  var overlay=document.getElementById('mm-overlay'); if(!overlay) return;
  var openBtns=[document.getElementById('mm-open'), document.getElementById('mm-open-add')];
  var closeBtn=document.getElementById('mm-close');
  var panel=overlay.querySelector('.mm-panel');
  var form=document.getElementById('product-form');
  var warn=document.getElementById('mm-warn');
  var unitValue=document.getElementById('mm-unit-value');
  var unitBtns=[document.getElementById('mm-unit-cm'), document.getElementById('mm-unit-in')];
  var fields=overlay.querySelectorAll('.mm-field input[data-min-cm]');

  function openModal(){ overlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeModal(){ overlay.classList.remove('open'); document.body.style.overflow=''; }
  openBtns.forEach(function(btn){ if(btn) btn.addEventListener('click', openModal); });
  if(closeBtn) closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e){ if(e.target===overlay) closeModal(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && overlay.classList.contains('open')) closeModal(); });

  function unit(){ return unitValue.value; }
  function round1(n){ return Math.round(n*10)/10; }

  function updateGuides(){
    fields.forEach(function(input){
      var minCm=parseFloat(input.dataset.minCm), maxCm=parseFloat(input.dataset.maxCm);
      var guide=input.closest('.mm-field').querySelector('.mm-guide');
      if(unit()==='in'){
        guide.textContent='Guide: '+round1(minCm/2.54)+'–'+round1(maxCm/2.54)+' in';
      } else {
        guide.textContent='Guide: '+minCm+'–'+maxCm+' cm';
      }
    });
  }

  unitBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var newUnit=btn.dataset.unit;
      if(newUnit===unit()) return;
      fields.forEach(function(input){
        var v=parseFloat(input.value);
        if(!isNaN(v)){
          input.value = newUnit==='in' ? round1(v/2.54) : round1(v*2.54);
        }
      });
      unitBtns.forEach(function(b){ b.classList.toggle('on', b===btn); });
      unitValue.value=newUnit;
      updateGuides();
    });
  });
  updateGuides();

  form.addEventListener('submit', function(e){
    var valid=true, firstInvalid=null;
    fields.forEach(function(input){
      var v=parseFloat(input.value);
      var minCm=parseFloat(input.dataset.minCm), maxCm=parseFloat(input.dataset.maxCm);
      var min=unit()==='in'?minCm/2.54:minCm, max=unit()==='in'?maxCm/2.54:maxCm;
      var ok = input.value!=='' && !isNaN(v) && v>=min && v<=max;
      input.style.borderColor = ok ? '' : 'var(--bordeaux)';
      if(!ok){ valid=false; if(!firstInvalid) firstInvalid=input; }
    });
    if(!valid){
      e.preventDefault();
      openModal();
      warn.hidden=false;
      if(firstInvalid) firstInvalid.focus();
    } else {
      warn.hidden=true;
    }
  });
})();

// "You may also like" — tries Shopify's native product recommendations, but the section
// already has a server-rendered same-collection fallback so it's never empty either way.
(function(){
  var el=document.getElementById('product-recommendations');
  if(!el || !el.dataset.url) return;
  fetch(el.dataset.url)
    .then(function(r){return r.text();})
    .then(function(html){
      var doc=new DOMParser().parseFromString(html, 'text/html');
      var wrapper=doc.querySelector('#shopify-section-product-recommendations');
      var content=wrapper ? wrapper.innerHTML.trim() : '';
      if(content){ el.innerHTML=content; }
    })
    .catch(function(){ /* keep the server-rendered fallback already in place */ });
})();
